import { CloseOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import styles from "../notification.module.css";

const Banner = ({ notification, dispatcher }) => {
  const [isMounted, setIsMounted] = useState(undefined);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  useEffect(() => {
    const notificationTimer = setTimeout(
      () => {
        setIsMounted(false);
      },
      notification.duration ? notification.duration : 5000
    );

    return () => {
      clearTimeout(notificationTimer);
    };
  }, []);

  useEffect(() => {
    if (isMounted === false) {
      setTimeout(() => {
        dispatcher({
          type: "closeNotification",
          id: notification.id,
        });
      }, 200);
    }
  }, [isMounted]);

  const handleCloseBannerClick = function () {
    setIsMounted(false);
  };

  return (
    <div
      className={`${styles.banner}
                 ${isMounted ? styles.banner_mounted : null} 
                 ${
                   notification.type === "success"
                     ? styles.banner_success
                     : notification.type === "failure"
                     ? styles.banner_failure
                     : ""
                 }`}
    >
      <div className={styles.body}>
        <div className={styles.message}>
          <span>{notification.message}</span>
        </div>
        <hr className={styles.separator} />
        <div className={styles.close_button}>
          <CloseOutlined
            className={styles.close_button}
            onClick={handleCloseBannerClick}
          />
        </div>
      </div>
    </div>
  );
};

export default Banner;
